import React from "react";
import PropTypes from "prop-types";
import { Icon } from "../../atoms/icon";

import styles from "./styles.m.css";

const MyVikatanBadgeSmall = ({ isMyVikatan = false, className = "" }) => {
  if (!isMyVikatan) {
    return null;
  } else {
    return (
      <span className={styles["premium-badge"]}>
        <Icon type="myvikatanbadge" className={styles["myvikatanbadge"]} />
      </span>
    );
  }
};

MyVikatanBadgeSmall.propTypes = {
  isMyVikatan: PropTypes.bool,
  className: PropTypes.string
};

export { MyVikatanBadgeSmall };
